import * as Sentry from '@sentry/react';
import mixpanel from 'mixpanel-browser';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthContextProvider } from './contexts/AuthContext';
import { SnackbarContextProvider } from './contexts/SnackbarContext';
import { UserContextProvider } from './contexts/UserContext';
import { WebsiteUpdaterContextProvider } from './contexts/WebsiteUpdaterContext';
import './index.css';
import './quill.bubble.css';
import './quill.mention.css';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN ?? '',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/internal-api\.betterfunnel\.ai/,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// import Hotjar from '@hotjar/browser';

// Initiate Hotjar only in prod

// const siteId = 0;
// const hotjarVersion = 6;
// Hotjar.init(siteId, hotjarVersion, {
//   debug: import.meta.env.NODE_ENV === 'development',
// });

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Timestamp as FirebaseTimestamp } from 'firebase/firestore';
import { AuditLogContextProvider } from './contexts/AuditLogContext';

declare module '@betterfunnel/types' {
  export type Timestamp = FirebaseTimestamp;
}

mixpanel.init(import.meta.env.VITE_MIXPANEL ?? '', {
  debug: import.meta.env.NODE_ENV === 'development',
  track_pageview: true,
  persistence: 'localStorage',
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SnackbarContextProvider>
          <AuthContextProvider>
            <UserContextProvider>
              <AuditLogContextProvider>
                <WebsiteUpdaterContextProvider>
                  <App />
                </WebsiteUpdaterContextProvider>
              </AuditLogContextProvider>
            </UserContextProvider>
          </AuthContextProvider>
        </SnackbarContextProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
